class Notifications {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.admins = undefined;
        this.branches = undefined;
        this.devicePostureChecks = undefined;

        this.categories = [
            {
                name: 'weekly_report',
                tabID: 'general_tab',
                wrapperID: 'weeklyReport_wrapper',
                datatableEl: document.getElementById('weekly-report-datatable'),
                datatableInstance: null
            },
            {
                name: 'gateway_maintenance',
                tabID: 'gateways_tab',
                wrapperID: 'gatewayNotifications_wrapper',
                datatableEl: document.getElementById('gateways-notifications-datatable'),
                datatableInstance: null
            },
            {
                name: 'device_approval',
                tabID: 'device_approval_tab',
                wrapperID: 'deviceApproval_wrapper',
                datatableEl: document.getElementById('device-approval-notifications-datatable'),
                datatableInstance: null
            },
            {
                name: 'api_integration_usage_limit',
                tabID: 'api_integration_usage_limit_tab',
                wrapperID: 'apiIntegrationUsageLimit_wrapper',
                datatableEl: document.getElementById('api-integration-usage-limit-datatable'),
                datatableInstance: null
            },
            {
                name: 'api_integration_token_expires',
                tabID: 'api_integration_token_expired_tab',
                wrapperID: 'apiIntegrationTokenExpires_wrapper',
                datatableEl: document.getElementById('api-integration-token-expires-datatable'),
                datatableInstance: null
            },
            {
                name: 'invoice',
                tabID: 'invoice_tab',
                wrapperID: 'invoiceNotifications_wrapper',
                datatableEl: document.getElementById('invoices-notifications-datatable'),
                datatableInstance: null
            },
            {
                name: 'subscription_licence_limit',
                tabID: 'subscription_limit_tab',
                wrapperID: 'subscriptionLicenceLimit_wrapper',
                datatableEl: document.getElementById('subscription-licence-limit-datatable'),
                datatableInstance: null
            },
            {
                name: 'upcoming_payment_info',
                tabID: 'upcoming_payment_info_tab',
                wrapperID: 'upcomingEmailInfo_wrapper',
                datatableEl: document.getElementById('expiration-emails-datatable'),
                datatableInstance: null
            },
            {
                name: 'admin_roles',
                tabID: 'admin_roles_tab',
                wrapperID: 'adminRoles_wrapper',
                datatableEl: document.getElementById('admin-roles-datatable'),
                datatableInstance: null
            },
        ];

        this.changeNotificationsStatus();
        this.initAdminsNotificationsDatatables();
        this.addAdminsToNotificationsFormValidation();

        this.tabChange();
    }
    changeNotificationsStatus(){
        const thisClass = this;
        document.querySelectorAll('input.notification-checkbox').forEach((checkbox) => {
            let actionCategory = checkbox.attributes['data-action-category'].value;
            let actionName = checkbox.attributes['data-action-name'].value;
            let have = checkbox.attributes['data-have'];
            checkbox.addEventListener('change', (event) => {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    let checked = event.currentTarget.checked;
                    let swalText = 'Are you sure you want to <b>'+(!checked ? 'disable' : 'enable')+'</b> '+actionName+'?';
                    Swal.fire({
                        html: `<span class="text-center text-primary">${swalText}</span>`,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                        showLoaderOnConfirm: true,
                        returnFocus: false,
                        preConfirm: () => {
                            return fetch('/notifications?do=changeNotificationValue&organizationID='+thisClass.organizationID+'&categoryName='+actionCategory+'&result='+(checked ? 1 : 0))
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(response.statusText)
                                    }
                                    return response.json();
                                }).catch(error => {
                                    Swal.showValidationMessage(`Request failed: ${error}`)
                                });
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        allowEscapeKey: () => !Swal.isLoading()
                    }).then((result) => {
                        if (result.isConfirmed) {
                            if(result.value === true){
                                let sectionStatusEl = document.querySelector('.menu-link[data-section-name="'+actionCategory+'"] .bullet.bullet-dot');
                                if(sectionStatusEl){
                                    if(sectionStatusEl.classList.contains('bg-success') && !checked){
                                        sectionStatusEl.classList.add('bg-danger');
                                        sectionStatusEl.classList.remove('bg-success');
                                    }
                                    if(sectionStatusEl.classList.contains('bg-danger') && checked){
                                        sectionStatusEl.classList.remove('bg-danger');
                                        sectionStatusEl.classList.add('bg-success');
                                    }
                                }
                                if(checked){
                                    toastr.success(actionName+' '+(have ? 'have' : 'has')+' been successfully enabled!');
                                } else {
                                    toastr.success(actionName+' '+(have ? 'have' : 'has')+' been successfully disabled!');
                                }
                            } else {
                                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                            }
                        } else {
                            checkbox.checked = !checked;
                        }
                    });
                }
            });
        });
    }
    tabChange(){
        const thisClass = this;

        // Init Branches
        const branchTabEl = document.querySelector('.menu-link[href="#branches_tab"]');
        let cloudBranchesInstance = null;
        branchTabEl.addEventListener('shown.bs.tab', async function (event) {
            if(!cloudBranchesInstance){
                const blockUI = new KTBlockUI(document.querySelector('#branchesAdmins_wrapper'), {
                    overlayClass: "ga-bg-primary-050",
                });
                blockUI.block();
                cloudBranchesInstance = new CloudBranches(await thisClass.getAllAdmins(), await thisClass.getAllBranches(), blockUI);
            }
        });
        branchTabEl.addEventListener('hide.bs.tab', async function (event) {
            if(cloudBranchesInstance && cloudBranchesInstance.changesMade){
                const confirmLeave = confirm("You have unsaved changes. Are you sure you want to continue?");
                if (!confirmLeave) {
                    event.preventDefault();
                }
            }
        });

        // Init Device Posture Check
        const devicePostureCheckTabEl = document.querySelector('.menu-link[href="#device_posture_check_tab"]');
        let devicePostureCheckInstance = null;
        devicePostureCheckTabEl.addEventListener('shown.bs.tab', async function (event) {
            if(!devicePostureCheckInstance){
                const blockUI = new KTBlockUI(document.querySelector('#devicePostureCheck_wrapper'), {
                    overlayClass: "ga-bg-primary-050",
                });
                blockUI.block();
                devicePostureCheckInstance = new DevicePostureChecks(await thisClass.getAllAdmins(), await thisClass.getAllDevicePostureChecks(), blockUI);
            }
        });
        devicePostureCheckTabEl.addEventListener('hide.bs.tab', async function (event) {
            if(devicePostureCheckInstance && devicePostureCheckInstance.changesMade){
                const confirmLeave = confirm("You have unsaved changes. Are you sure you want to continue?");
                if (!confirmLeave) {
                    event.preventDefault();
                }
            }
        });
    }
    async getAllAdmins() {
        if (this.admins !== undefined) {
            return this.admins;
        }

        const response = await fetch('/notifications/?do=getAllAdmins&organizationID=' + this.organizationID);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        this.admins = data;
        return data;
    }
    async getAllBranches() {
        if (this.branches !== undefined) {
            return this.branches;
        }

        const response = await fetch('/notifications/?do=getAllBranches&organizationID=' + this.organizationID);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        this.branches = data;
        return data;
    }
    async getAllDevicePostureChecks() {
        if (this.devicePostureChecks !== undefined) {
            return this.devicePostureChecks;
        }

        const response = await fetch('/notifications/?do=getAllDevicePostureChecks&organizationID=' + this.organizationID);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        this.devicePostureChecks = data;
        return data;
    }
    async initAdminsNotificationsDatatables() {
        const thisClass = this;
        this.categories.forEach((category) => {
            if(category.name === 'weekly_report'){
                category.datatableInstance = new AdminNotificationDatatable('weekly_report', thisClass.getAllAdmins(), category.datatableEl, document.getElementById(category.tabID), document.getElementById(category.wrapperID));
            } else {
                let tab = document.querySelector('.menu-link[href="#'+category.tabID+'"]');
                if(tab){
                    tab.addEventListener('shown.bs.tab', async function (event) {
                        if(category.datatableInstance === null){
                            category.datatableInstance = new AdminNotificationDatatable(category.name, thisClass.getAllAdmins(), category.datatableEl, document.getElementById(category.tabID), document.getElementById(category.wrapperID));
                        }
                    });
                }
            }
        });
    }
    addAdminsToNotificationsFormValidation(){
        const thisClass = this;
        let form = document.getElementById('frm-addAdminsToNotificationsForm-addAdminsToNotificationsForm');
        if(form){
            let submitButton = document.getElementById('add_admins_to_notifications_modal_submit');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'adminsToAdd': {
                            validators: {
                                notEmpty: {
                                    enabled: false,
                                    message: 'This field is required',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            );

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        new DismissModal('add_admins_to_notifications_modal').disable();
                        // Show loading indication
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        // Disable button to avoid multiple click
                        submitButton.disabled = true;
                        $(form).submit();
                    }
                });
            });

            $.nette.ext('addAdminsToNotifications', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-addAdminsToNotificationsForm-addAdminsToNotificationsForm'){
                        if(payload.success){
                            toastr.success(payload.message);
                        } else {
                            toastr.error(payload.message);
                        }

                        new DismissModal('add_admins_to_notifications_modal').enable();
                        bootstrap.Modal.getInstance(document.getElementById('add_admins_to_notifications_modal')).hide();

                        form.querySelector('input[name=adminsToAdd]').value = '';
                        let categoryName = form.querySelector('input[name=categoryName]').value;
                        let selectedCategory = thisClass.categories.filter(category => category.name === categoryName);
                        selectedCategory[0].datatableInstance.reloadData();

                        // Cancel loading indication
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                    }
                }
            });
        }
    }
}
window.Notifications = Notifications;